var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRate5(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M42 21c0 11.598-9.402 21-21 21S0 32.598 0 21 9.402 0 21 0s21 9.402 21 21z",
    fill: props.fill
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.427 16.113c0 1.813-1.028 3.282-2.297 3.282-1.268 0-2.296-1.47-2.296-3.282s1.028-3.281 2.296-3.281c1.269 0 2.297 1.47 2.297 3.281zM29.24 16.113c0 1.813-1.029 3.282-2.297 3.282-1.269 0-2.297-1.47-2.297-3.282s1.028-3.281 2.297-3.281c1.268 0 2.297 1.47 2.297 3.281z",
    fill: "#111827"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.188 25.922c0 .99.305 1.972.899 2.888.593.916 1.463 1.748 2.56 2.448 1.097.701 2.4 1.257 3.833 1.636 1.433.38 2.969.575 4.52.575a17.77 17.77 0 004.52-.575c1.434-.379 2.736-.935 3.833-1.636 1.097-.7 1.967-1.532 2.56-2.448.594-.916.9-1.897.9-2.888H9.186z",
    fill: "#fff"
  })));
}
export default SvgRate5;